import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Disclaimer } from 'site-modules/shared/components/native-ad/native-ad-components/disclaimer/disclaimer';

import { CPO_FEATURE_NAMES } from './cpo-constants';

import './cpo-features-list.scss';

export function CpoFeaturesList({
  isButtonAd = false,
  isUsurpAd = false,
  isPfWired = false,
  featuresListLength = CPO_FEATURE_NAMES.default.length,
  textColor = 'text-cool-gray-30',
  make = null,
}) {
  const featuresLengthToUse = isButtonAd ? 2 : featuresListLength;
  const featureNamesToUse = CPO_FEATURE_NAMES[make?.toLowerCase()] || CPO_FEATURE_NAMES.default;
  const featuresToUse = featureNamesToUse.slice(0, featuresLengthToUse);
  return (
    <ul
      className={classnames('cpo-features-list list-unstyled d-flex flex-column', {
        'mt-1_5': !isButtonAd && !isPfWired,
        'mt-1': isButtonAd,
        'mb-1_5': isUsurpAd,
        'ps-1 mt-0_5 mb-0': isPfWired,
        'is-fill-white': textColor === 'text-white',
      })}
      style={{ gap: featuresLengthToUse < 3 ? '0.5rem' : '1.25rem' }}
    >
      {featuresToUse.map(feature => (
        <li
          key={feature.name}
          className={classnames('d-flex align-items-center', {
            'mb-0_25': isButtonAd,
          })}
          style={{ height: '24px' }}
        >
          {feature.icon}
          <span
            className={classnames('size-14', textColor, {
              'ms-1_5': !isButtonAd && featuresLengthToUse === 4,
              'ms-0_5': isButtonAd || featuresLengthToUse !== 4,
            })}
            style={{ lineHeight: '1rem' }}
          >
            {feature.name}
          </span>
          <Disclaimer
            ariaLabel="View Disclaimer"
            linkDisclaimer=""
            disclaimerText={feature.disclaimer}
            buttonClasses="size-14 cool-gray-30 p-0_25 d-flex"
            buttonStyle={{ zIndex: 1 }}
            contentClasses="p-1_5"
            useHeading
            useIconInfo
          />
        </li>
      ))}
    </ul>
  );
}

CpoFeaturesList.propTypes = {
  isButtonAd: PropTypes.bool,
  isUsurpAd: PropTypes.bool,
  isPfWired: PropTypes.bool,
  featuresListLength: PropTypes.number,
  textColor: PropTypes.string,
  make: PropTypes.string,
};
